import { useEffect } from 'react';
import { useCurrentAccount } from './useCurrentAccount';
import { accountQueryKeys } from 'queries/account-query-keys';
import { queryClient } from 'queries/queryClient';
import { Appeal } from 'types/domain';

const usePreloadAppealFromResource = (appeal?: Appeal | null) => {
    const { accountId } = useCurrentAccount();

    useEffect(() => {
        if (!appeal) return;

        queryClient.setQueryData(accountQueryKeys.appealById(accountId, appeal.id), appeal);
    }, [appeal, accountId]);
};

export { usePreloadAppealFromResource };
